import React, { useEffect, useState, useRef } from 'react'
import { useParams } from 'react-router-dom'
import APIUrls from '../../services/APIUrls'
import { getAxiosResponse, putAxiosResponse } from '../../services/authApiRoutes/APImethods'
import Select from 'react-select';
import { dateConvertToTimeStamp, humanize, TIME_LIST } from '../../services/Util'
import DatePickerCalendar from '../dashboard/calendars/DatePickerCalendar';
import { useSelector, useDispatch } from 'react-redux'
import { updateProjectInfoValidation } from '../../redux/reducers/ProjectInfoValidationSlice';
import { updateProjectInfo } from '../../redux/reducers/ProjectInfoSlice';
import Constants from '../../Constants';
import { useTranslation } from 'react-i18next';
import $ from "jquery";
import ReactTooltip from 'react-tooltip';
import { ConditionalBlock } from '../../ConditionalBlock';
import dateUtil from "../../services/DateUtil";
import DateFormat from "../../pages/DateFormat";
import CustomToolTips from '../global/CustomToolTips';


export const MachineTranslation = () => {
	const { t } = useTranslation();
	const translate = t;
	const params = useParams()
	const refCalendar = useRef(null);
	const refToggle = useRef(null);
	const machineTranslationTooltipRef = useRef(null);
	const dispatch = new useDispatch();

	const [machineTranslationData, setMachineTranslationData] = useState([]);
	const [customerPurchaseOrder, setCustomerPurchaseOrder] = useState([]);
	const [toggle, toggleCal] = useState(false);
	const [customerPurchaseOrderData, setCustomerPurchaseOrderData] = useState([]);
	const [deliveryDueTime,setDeliveryDueTime] = useState(-1);
	const [selectedEngineType, setSelectedEngineType] = useState(null);
	const [invalidLanguages, setInvalidLanguages] = useState([]);
	
	const errorData = useSelector((reduxStore) => reduxStore.project_info_validation_slice).value;
	const projectData = useSelector((reduxStore) => reduxStore.project_info).value;
	const custBootstrapDataRedux = useSelector((reduxStore) => reduxStore.customer_bootstrap_data).value;
	const userTimeZone = custBootstrapDataRedux?.user?.timeZone;

	const setProjectInfoValidationToRedux = (type, value) => {
		dispatch(updateProjectInfoValidation({type: type, value: value}));
	}
	const dispatchFinalDataToRedux = (type, value) => {
		dispatch(updateProjectInfo({type: type, value: value}));
	}

	const setMachineTranslationVendor = (data, index) => {
		machineTranslationData.forEach((obj, i) => {
			if (i === index) {
			  data.checked ? obj.checked = false  : obj.checked = true
			  dispatchFinalDataToRedux('translationEngineType', data.code)
			} else {
			  	obj.checked = false;
			}
			return data;
		  })
		  setSelectedEngineType(data.code);
	}

	const machineTranslationVendorSelectionOnKeyDown = (event, index, data) => {
		if(event.key === Constants.ENTER) {
			setMachineTranslationVendor(data, index);
		}
	}
	
	const setCustomerPO = (event) => {
		if(event !==null){
		  const po = customerPurchaseOrderData.filter(data => data.id == event.value)
		  dispatchFinalDataToRedux('purchaseOrder', po[0])
		}else{
		  dispatchFinalDataToRedux('purchaseOrder', null)
		}
		setProjectInfoValidationToRedux('purchaseOrder', Constants.BLANK);
	  }


	useEffect(() => {
		customerUserPrefrence();
		getAllCustomerPurchaseOrder();
		dispatchFinalDataToRedux(
			'status', 'CONFIGURED_BID_OPTIONS'
		)
		dispatchFinalDataToRedux('projectVendorType', 'MACHINE_TRANSLATION')
		if(projectData.deliveryDueDate){
			setDeliveryDueTime(dateUtil.convertToServerMoment(projectData?.deliveryDueDate).hour())
		}
		machineTranslation();
		setProjectInfoValidationToRedux('deliveryDueDate', Constants.BLANK);
		setProjectInfoValidationToRedux('purchaseOrder', Constants.BLANK);
	}, [])

	useEffect(() => {
		let hasInvalidLanguages = false;
		let unavailableLanguages = [];
		if(selectedEngineType !== null) {
			getAxiosResponse(APIUrls.MACHINE_TRANSLATION_LANGUAGE_AVAILABILITY(params.id, selectedEngineType))
			.then((res) => {
				if(res.data.data.resource && res.data.data.resource.length !== 0) {
					res.data.data.resource.map((availabilityDetails, languageIndex) => {
						if(availabilityDetails.available === false) {
							hasInvalidLanguages = true;
							dispatchFinalDataToRedux('translationEngineType', null)
							unavailableLanguages.push(res.data.data.displayName[languageIndex].display);
						}
					})
					setInvalidLanguages(unavailableLanguages);
				}
			})
		}
		if(!hasInvalidLanguages) {
			setInvalidLanguages([]);
		}
	}, [selectedEngineType]);

	const customerUserPrefrence = async () => {
		const result = await putAxiosResponse(APIUrls.CUSTOMER_USER_PREFRENCE);
	}
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (
				refCalendar.current &&
				!refCalendar.current?.contains(event.target) &&
				!refToggle.current?.contains(event.target)
			) {
				toggleCal(false);
			}
		};

		document.addEventListener("click", handleClickOutside, true);
		return () => {
			document.removeEventListener("click", handleClickOutside, true);
		};
	}, [refCalendar]);
	const closeCalendar = (e) => {
		if (e.code === "Escape") {
			toggleCal(false);
			$('.cal-secondFocus').trigger('focus');
			$('#cal-secondFocus').removeClass('cal-secondFocus');
		}
	};
	const machineTranslation = async () => {
		if(projectData.translationEngineType !==null){
			const dateTimestamp = dateConvertToTimeStamp();
			const result = await getAxiosResponse(APIUrls.MACHINE_TRANSLATION(params.id) + `?_=${dateTimestamp}`)
			if(result.data.data && result.data.data.length > 0){
				result.data.data.forEach(data=>{
				if(data.code===projectData.translationEngineType.code){
					data.checked=true
				}
				})
			setMachineTranslationData(result.data.data)

			}
		}else{
			const dateTimestamp = dateConvertToTimeStamp();
			const result = await getAxiosResponse(APIUrls.MACHINE_TRANSLATION(params.id) + `?_=${dateTimestamp}`)
			setMachineTranslationData(result.data.data)
		}
	}

	const setTime = (event) =>{
		let currentDeliveryDueDate = dateUtil.convertToServerMoment(projectData.deliveryDueDate);
		currentDeliveryDueDate.set({
            'hour': parseInt(event.value),
            'minute': 0,
            'second': 0,
            'millisecond': 0,
          })
		dispatchFinalDataToRedux('deliveryDueDate', dateUtil.timestampObj(currentDeliveryDueDate, true));
		setDeliveryDueTime(event.value)
	}

	const getAllCustomerPurchaseOrder = async () => {
		const dateTimestamp = dateConvertToTimeStamp();
		const result = await getAxiosResponse(APIUrls.CUSTOMER_PURCHASE_ORDER + `?_=${dateTimestamp}`)
		setCustomerPurchaseOrderData(result.data.data)
		if(result?.data?.data && result?.data?.data.length > 0){
		const purchaseOrderData =result?.data?.data.map(({ shortDisplay, id }) => ({
			value: id,
			label: shortDisplay
		}))
		setCustomerPurchaseOrder(purchaseOrderData)
		setCustomerPurchaseOrderData(result.data.data)
	}
	}

	const setDeliveryDueDate = (event) => {
		let newDeliveryDueDate = dateUtil.convertToServerMoment(event).set({
			'hour': deliveryDueTime === -1? 0 : deliveryDueTime,
			'minute': 0,
			'second': 0,
			'millisecond': 0,
		});
		let isDateGreaterThanWorkspaceDueDate = projectData?.workspace !== null ? newDeliveryDueDate.isAfter(dateUtil.convertToServerMoment(projectData?.workspace?.dueDate)) : false;
		if(isDateGreaterThanWorkspaceDueDate) {
			dispatchFinalDataToRedux('deliveryDueDateExceeded', true);
			setProjectInfoValidationToRedux('deliveryDueDate',  `The selected translation deadline is after the project campaign's due date of ${dateUtil.format(projectData?.workspace?.dueDate)}. If this is incorrect, please select a different date.`);
		} else {
			dispatchFinalDataToRedux('deliveryDueDateExceeded', false);
			setProjectInfoValidationToRedux('deliveryDueDate', Constants.BLANK);
		}
		dispatchFinalDataToRedux('deliveryDueDate', dateUtil.timestampObj(newDeliveryDueDate, true));
		setProjectInfoValidationToRedux('projectDueDateInternalTranslator', false)
		$('.cal-secondFocus').trigger('focus')
		toggleCal(false);
	}
	$(".cal-secondFocus").on("keydown", function (e) {
		if (e.key === Constants.ESCAPE) {
			if($('div').hasClass('dashCalendarInternal')){
			setTimeout(() => {
				toggleCal(false);
				$('.cal-secondFocus').trigger('focus')
				$('.cal-secondFocus').removeClass('cal-secondFocus')
			}, 100);
			}
		}
		if (e.key === Constants.TAB && e.shiftKey) {
			if($('div').hasClass('dashCalendarInternal')){
				toggleCal(false);
				$('.cal-secondFocus').trigger('focus')
				$('.cal-secondFocus').removeClass('cal-secondFocus')
			}
		}
	});
	const showCalendarDueDate = (e) => {
		toggle ? toggleCal(false) : toggleCal(true);
		$('#cal-secondFocus').toggleClass('cal-secondFocus')
		$('.cal-secondFocus').trigger('focus')
		$(document).mouseup(function(e) {
		  var bannerCont = $('.cal-secondFocus');
		  if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
			$('.cal-secondFocus').removeClass('cal-secondFocus');
		 }
		});
		if (toggle) {
			var requiredElement = document.querySelector(".dashCalendarInternal");
			requiredElement.focus();
		}
	};
	useEffect(()=>{
		$.each($('.react-calendar__tile'), function( index, value ) {
		  $(value).attr('aria-label', value.children[0].ariaLabel);
		});
	});

	return (
		<div className="translate-project translate-vender">
			<ConditionalBlock condition={invalidLanguages[0] !== undefined && invalidLanguages[0].length !== 0}>
				<div className="bids-table mar-bot10">
					<ul>
						<li>
							<p className="error-alert m-0">{translate("other_integrations_project_creation.mt_language_availability_common")} {invalidLanguages.join(', ')}<br/><br/>
								{projectData?.targetLanguages?.length === invalidLanguages[0]?.length ? translate("other_integrations_project_creation.mt_language_availability_all")
									: translate("other_integrations_project_creation.mt_language_availability_some")}
							</p>
						</li>
					</ul>
				</div>
			</ConditionalBlock>
			<div className="project-heading">
				<h3>{translate("other_integrations_project_creation.machine_translation_engines")}</h3>
			</div>
			<div className="vendor-content">
				<h5 id='machine-radioGroup'>{translate("other_integrations_project_creation.mandatory_machine_translation")}</h5>
				<div className="translate-box flex"  role="radiogroup" aria-labelledby="machine-radioGroup">
					{
						 machineTranslationData && machineTranslationData.length > 0 ? machineTranslationData.map((data, index) => (
							<><div key={index} className="translate-box-list" role='none'>
								<a tabindex="0"
								 role="radio"
								 aria-checked={data?.checked ? ' true' : 'false'}
								 onClick={() => setMachineTranslationVendor(data, index)}
							     onKeyDown={(e) => machineTranslationVendorSelectionOnKeyDown(e, index, data)}
							    className={data?.checked ? ' vendor' : ''}>
									<span>{data.display}</span>
								</a>
							</div>
							{<ConditionalBlock condition={data.code === 'WELOCALIZE_TRANSLATE'}>
								<CustomToolTips dataTip={translate("welocalize_mt_tooltip")} toolTipRef={machineTranslationTooltipRef} toolTipId="welocalizeMT" />
							</ConditionalBlock>}
							</>
						)) : null
					}

				</div>
				<p className="note-indicator">
					<strong>Note: </strong>{translate("other_integrations_project_creation.time_sensitive_projects")}
				</p>
				<div className="vender-form-block">
					<h5>{translate("other_integrations_project_creation.translation_deadline")}</h5>
					<div className="flex wrap-dropdown wrap-group-dropdown">
						<div className="global-dropdown-block flex-center">
							<label>{translate("other_integrations_project_creation.initial_translation_machine_translator")}
							<div className='tooltip-container optional-tooltip'>
								<p
									tabindex={0} data-events={['focus']} data-eventsoff={['blur']}
									data-padding="10px 10px 10px 10px"
									data-place="right"
									data-tip={Constants.TRANSLATION_SUBMISSION_TOOLTIP}
									data-for="translation-submission-tooltip"
									aria-label="Tooltip"
									id='translationTooltip'
								>
									<svg
									className="svg-tooltip-icon"
									viewBox="0 0 1024 1024"
									version="1.1"
									xmlns="http://www.w3.org/2000/svg"
									>
									<path d="M512 81.408a422.4 422.4 0 1 0 422.4 422.4A422.4 422.4 0 0 0 512 81.408z m26.624 629.76a45.056 45.056 0 0 1-31.232 12.288 42.496 42.496 0 0 1-31.232-12.8 41.984 41.984 0 0 1-12.8-30.72 39.424 39.424 0 0 1 12.8-30.72 42.496 42.496 0 0 1 31.232-12.288 43.008 43.008 0 0 1 31.744 12.288 39.424 39.424 0 0 1 12.8 30.72 43.008 43.008 0 0 1-13.312 31.744z m87.04-235.52a617.472 617.472 0 0 1-51.2 47.104 93.184 93.184 0 0 0-25.088 31.232 80.896 80.896 0 0 0-9.728 39.936v10.24h-64v-10.24a119.808 119.808 0 0 1 12.288-57.344A311.296 311.296 0 0 1 555.52 460.8l10.24-11.264a71.168 71.168 0 0 0 16.896-44.032A69.632 69.632 0 0 0 563.2 358.4a69.632 69.632 0 0 0-51.2-17.92 67.072 67.072 0 0 0-58.88 26.112 102.4 102.4 0 0 0-16.384 61.44h-61.44a140.288 140.288 0 0 1 37.888-102.4 140.8 140.8 0 0 1 104.96-38.4 135.68 135.68 0 0 1 96.256 29.184 108.032 108.032 0 0 1 36.352 86.528 116.736 116.736 0 0 1-25.088 73.216z" />
									</svg>
									<div className="font-zero">{Constants.TRANSLATION_SUBMISSION_TOOLTIP}</div>
								</p>
								<ReactTooltip className="tooltip" id="translation-submission-tooltip" role='tooltip' />
							</div>
							</label>
							<div className="flex-center w-d100">
								<div className="global-dropdown-select">
								<label htmlFor='cal-secondFocus' className='font-zero'>{translate("other_integrations_project_creation.initial_translation_machine_translator")}</label>
									<button onClick={(e) => {showCalendarDueDate(e);}} required role="combobox" aria-haspopup="dialog"
										aria-expanded={toggle ? 'true':'false'} aria-label={projectData?.deliveryDueDate ? `${dateUtil.format(projectData?.deliveryDueDate)} selected` : 'choose date dialog'}
										ref={refToggle} tabIndex={0} id='cal-secondFocus' type="button" className="drop-down-btn gb-dropBtn">
										<span>
											<DateFormat date={projectData?.deliveryDueDate}/>
										</span>

										<svg className="calender-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none">
											<path d="M12 1.66666H10V0.666662C10 0.578256 9.96492 0.493472 9.90241 0.430959C9.8399 0.368447 9.75511 0.333328 9.66671 0.333328C9.5783 0.333328 9.49352 0.368447 9.431 0.430959C9.36849 0.493472 9.33337 0.578256 9.33337 0.666662V1.66666H4.66671V0.666662C4.66671 0.578256 4.63159 0.493472 4.56908 0.430959C4.50656 0.368447 4.42178 0.333328 4.33337 0.333328C4.24497 0.333328 4.16018 0.368447 4.09767 0.430959C4.03516 0.493472 4.00004 0.578256 4.00004 0.666662V1.66666H2.00004C1.55818 1.66719 1.13456 1.84296 0.822114 2.1554C0.509668 2.46785 0.333903 2.89146 0.333374 3.33333V12C0.333903 12.4419 0.509668 12.8655 0.822114 13.1779C1.13456 13.4904 1.55818 13.6661 2.00004 13.6667H12C12.442 13.6663 12.8657 13.4906 13.1782 13.1781C13.4906 12.8656 13.6664 12.4419 13.6667 12V3.33333C13.6664 2.89141 13.4906 2.46769 13.1782 2.15521C12.8657 1.84272 12.442 1.66701 12 1.66666ZM13 12C13 12.2652 12.8947 12.5196 12.7071 12.7071C12.5196 12.8946 12.2653 13 12 13H2.00004C1.73482 13 1.48047 12.8946 1.29293 12.7071C1.1054 12.5196 1.00004 12.2652 1.00004 12V6.33333H13V12ZM13 5.66666H1.00004V3.33333C1.00004 2.78133 1.44671 2.33333 2.00004 2.33333H4.00004V3.33333C4.00004 3.42173 4.03516 3.50652 4.09767 3.56903C4.16018 3.63154 4.24497 3.66666 4.33337 3.66666C4.42178 3.66666 4.50656 3.63154 4.56908 3.56903C4.63159 3.50652 4.66671 3.42173 4.66671 3.33333V2.33333H9.33337V3.33333C9.33337 3.42173 9.36849 3.50652 9.431 3.56903C9.49352 3.63154 9.5783 3.66666 9.66671 3.66666C9.75511 3.66666 9.8399 3.63154 9.90241 3.56903C9.96492 3.50652 10 3.42173 10 3.33333V2.33333H12C12.2653 2.33333 12.5196 2.43868 12.7071 2.62622C12.8947 2.81376 13 3.06811 13 3.33333V5.66666Z" fill="#3564EB"/>
										</svg>
									</button>
								</div>
								{toggle ? (<div ref={refCalendar} onKeyDown={(e) => {closeCalendar(e);}}>
									<DatePickerCalendar value={projectData?.deliveryDueDate ? new Date(dateUtil.convertToLocalDateTimestamp(projectData?.deliveryDueDate)) : ""}
														minDate={new Date()}
									className={"dashCalendarInternal"} selectDate={setDeliveryDueDate} />
								</div>) : ("")}
								
									<Select className="global-dropdown-select small-dropdown-select" classNamePrefix='cw'
									value={TIME_LIST.filter(function (option) {
										return option?.value === deliveryDueTime;
									  })}  
									  aria-label="What Time?"
									  onChange={event => setTime(event)}       
										options={TIME_LIST}
										menuShouldScrollIntoView={false}
									/>
							</div>
							{errorData.deliveryDueDate && <p className='textDanger'>{errorData.deliveryDueDate}</p>}
						</div>
					</div>

					<div className="flex wrap-dropdown mb-0">
						<div className="global-dropdown-block flex-center mb-0">
							<label>{translate("other_integrations_project_creation.po_number")}
								<div className='tooltip-container optional-tooltip'>
									<p tabindex={0} data-events={['focus']} data-eventsoff={['blur']}
									data-padding='10px 10px 10px 10px'
									id='purchaseOrderTooltip'
									aria-label='tooltip'
									data-place='bottom'
									data-tip={Constants.PURCHASE_ORDER_TOOLTIP}
									data-for='purchaseOrderTip'>
										<svg className="svg-tooltip-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
											<path d="M512 81.408a422.4 422.4 0 1 0 422.4 422.4A422.4 422.4 0 0 0 512 81.408z m26.624 629.76a45.056 45.056 0 0 1-31.232 12.288 42.496 42.496 0 0 1-31.232-12.8 41.984 41.984 0 0 1-12.8-30.72 39.424 39.424 0 0 1 12.8-30.72 42.496 42.496 0 0 1 31.232-12.288 43.008 43.008 0 0 1 31.744 12.288 39.424 39.424 0 0 1 12.8 30.72 43.008 43.008 0 0 1-13.312 31.744z m87.04-235.52a617.472 617.472 0 0 1-51.2 47.104 93.184 93.184 0 0 0-25.088 31.232 80.896 80.896 0 0 0-9.728 39.936v10.24h-64v-10.24a119.808 119.808 0 0 1 12.288-57.344A311.296 311.296 0 0 1 555.52 460.8l10.24-11.264a71.168 71.168 0 0 0 16.896-44.032A69.632 69.632 0 0 0 563.2 358.4a69.632 69.632 0 0 0-51.2-17.92 67.072 67.072 0 0 0-58.88 26.112 102.4 102.4 0 0 0-16.384 61.44h-61.44a140.288 140.288 0 0 1 37.888-102.4 140.8 140.8 0 0 1 104.96-38.4 135.68 135.68 0 0 1 96.256 29.184 108.032 108.032 0 0 1 36.352 86.528 116.736 116.736 0 0 1-25.088 73.216z" />
										</svg>
										<div className="font-zero">{Constants.PURCHASE_ORDER_TOOLTIP}</div>
									</p>
									<ReactTooltip
									className='tooltip'
									id='purchaseOrderTip'
									role='tooltip'
									></ReactTooltip>
								</div>
								<span>Optional</span>
							</label>
							<div className="global-dropdown-select">
								<Select classNamePrefix='cw' menuShouldScrollIntoView={false} 
									value={ customerPurchaseOrder.filter(function (option) {
										return option?.value === projectData?.purchaseOrder?.id;
									}) }
									aria-label="Purchase Order Number"
									isClearable={true}
									className="global-dropdown-select" onChange={e => { setCustomerPO(e) }} options={customerPurchaseOrder} />
							</div>
							{errorData.purchaseOrder && <p className='textDanger'>{errorData.purchaseOrder}</p>}
						</div>
					</div>

				</div>

			</div>
		</div>
	)
}
